import PrivacyPolicySectionContent from "@app/components/privacy-policy-sections/content";
import PrivacyPolicySectionHeader from "@app/components/privacy-policy-sections/header";

const PrivacyPolicyPage = () => {
  return (
    <section
      className="m-6 md:m-20 flex flex-col gap-y-5 md:gap-y-10
      items-center"
    >
      <PrivacyPolicySectionHeader />
      <PrivacyPolicySectionContent />
    </section>
  );
};

export default PrivacyPolicyPage;
